define('Hammer-exported',["Hammer"], function (Hammer) {
	return window.Hammer = Hammer;
});
